window.nobid_environment = 'prod'
const endpoint = process.env.REACT_APP_API_ENDPOINT || 'reports.nobid.io';
window.nobid_endpoint = `https://${endpoint}/console`;

if (process.env['NODE_ENV']==='development') {
	window.nobid_environment = 'dev';
	window.nobid_endpoint = 'http://localhost:3000/console';
}

// Tenant slug extraction from subdomain (e.g., acme.nobid.io -> acme)
// Also supports ?tenant=slug query param for local testing
const hostname = window.location.hostname;
const parts = hostname.split('.');
// Check both regular query params and hash-based query params (React-Admin uses hash routing)
let tenantParam = new URLSearchParams(window.location.search).get('tenant');
if (!tenantParam) {
	const hash = window.location.hash;
	const hashQuery = hash.indexOf('?') > -1 ? hash.substring(hash.indexOf('?')) : '';
	tenantParam = new URLSearchParams(hashQuery).get('tenant');
}
// Also support cookie for persistence across page navigations
if (tenantParam) {
	document.cookie = `nobid_tenant=${tenantParam};path=/`;
} else {
	const match = document.cookie.match(/nobid_tenant=([^;]+)/);
	if (match) tenantParam = match[1];
}
const skipSubdomains = ['www', 'reports', 'localhost'];
window.nobid_tenant_slug = tenantParam || ((parts.length > 2 && !skipSubdomains.includes(parts[0])) ? parts[0] : null);

// Fetch tenant branding from public endpoint (no auth required)
window.nobid_branding = null;
window.nobid_branding_loaded = false;
window.nobid_fetch_branding = async function () {
  if (window.nobid_branding_loaded) return window.nobid_branding;
  const slug = window.nobid_tenant_slug;
  if (!slug) { window.nobid_branding_loaded = true; return null; }
  try {
    const response = await fetch(`${window.nobid_endpoint}/organizations/branding/${slug}`);
    const data = await response.json();
    if (data && data.branding) {
      window.nobid_branding = data.branding;
      window.nobid_branding.display_name = data.name;
    }
  } catch (e) {
    // Fallback to default NoBid branding on error
  }
  window.nobid_branding_loaded = true;
  return window.nobid_branding;
};

// Returns 'dark' or 'default' for react-data-table-component theme prop
window.nobid_table_theme = function () {
  try {
    const branding = JSON.parse(localStorage.getItem('nobid_branding'));
    return branding && branding.palette_type === 'light' ? 'default' : 'dark';
  } catch (e) { return 'dark'; }
};
